import { mapState } from 'vuex'

export default {
  props: {
    fieldRedirection: { type: String }
  },
  computed: {
    ...mapState({
      content: state => state.kreaEducationalContent.content
    })
  },
  mounted() {
    if (this.fieldRedirection && this.content) this.$nextTick(this.redirectToField)
  },
  watch: {
    content() {
      if (this.fieldRedirection) this.$nextTick(this.redirectToField)
    }
  },
  methods: {
    redirectToField() {
      const element = document.getElementById(this.fieldRedirection)
      const navbarOffset = 90
      const progressBarOffset = 90
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - (navbarOffset + progressBarOffset)

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }
}
